import { useTenant } from "@/hooks/useTenant";
import { useMemo } from "react";

export function useUserRole() {
  const { currentRole, isLoading } = useTenant();

  return useMemo(
    () => ({
      isSuperAdmin: currentRole === "super_admin",
      isAdmin: currentRole === "admin" || currentRole === "super_admin",
      hasRole: currentRole !== null,
      isLoading,
    }),
    [currentRole, isLoading],
  );
}
